import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  icon: {
    boxShadow: 'inset 0 0 0 1px #999',
    border: 'none',
    borderRadius: 4,
    position: 'relative',
    height: 16,
    width: 16,
    transition: '.2s'
  },
  checkedIcon: {
    backgroundColor: theme.palette.primary.main,
    boxShadow: 'none',
    '&:before': {
      position: 'absolute',
      backgroundImage: 'url(\'data:image/svg+xml,%3csvg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" fill="none" stroke-width="2px" stroke="white" stroke-linecap="round" viewbox="0 0 21 21"%3e%3cpolyline points="5 10.75 8.5 14.25 16 6"%3e%3c/polyline%3e%3c/svg%3e\')',
      content: '""',
      width: 16,
      height: 16,
      left: -2,
      top: -2,
    },
    '&:after': {
      position: 'absolute',
    },
    'input:hover ~ &': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  checked: {
    color: `${theme.palette.primary.main} !important`
  }
}));

export default useStyles;
